import { PocSkeletonLoader } from 'commons/components/components-wrapper';
import styled from 'styled-components';

export const SkeletonNoLoginLayout = styled.div`
    width: 100%;
    height: 100%;
`;

export const SkeletonNoLoginHeaderLayout = styled.div`
    height: 3rem;

    owc-skeleton-loader {
        width: calc(100% - 20px);
        height: 100%;
        margin: 10px;
    }
`;

export const SkeletonNoLoginContentLayout = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
`;

export const SkeletonLoaderMenu = styled(PocSkeletonLoader)`
    width: 292px;
    height: calc(100% - 5rem);
    margin: 10px;
`;

export const SkeletonLoaderMainContent = styled(PocSkeletonLoader)`
    width: calc(100% - 306px);
    height: calc(100% - 5rem);
    margin: 10px;
`;
